/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketpaymentsnotsetuperror5Inputs */

const en_ticketpaymentsnotsetuperror5 = /** @type {(inputs: Ticketpaymentsnotsetuperror5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set up payouts with Stripe first.`)
};

const de_ticketpaymentsnotsetuperror5 = /** @type {(inputs: Ticketpaymentsnotsetuperror5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Richte zuerst Auszahlungen mit Stripe ein.`)
};

/**
* | output |
* | --- |
* | "Set up payouts with Stripe first." |
*
* @param {Ticketpaymentsnotsetuperror5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpaymentsnotsetuperror5 = /** @type {((inputs?: Ticketpaymentsnotsetuperror5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpaymentsnotsetuperror5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpaymentsnotsetuperror5(inputs)
	return de_ticketpaymentsnotsetuperror5(inputs)
});
export { ticketpaymentsnotsetuperror5 as "ticketPaymentsNotSetUpError" }